var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#58588D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.75 11v6M15.75 14h-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#58588D",
    strokeWidth: 1.5,
    d: "M8.75 4.083c-1.304.105-2.208.34-2.939.872A5 5 0 0 0 4.705 6.06C3.75 7.375 3.75 9.251 3.75 13c0 3.75 0 5.625.955 6.939a5 5 0 0 0 1.106 1.106C7.125 22 9.001 22 12.75 22c3.75 0 5.625 0 6.939-.955a5 5 0 0 0 1.106-1.106c.955-1.314.955-3.19.955-6.939 0-3.75 0-5.625-.955-6.939a5 5 0 0 0-1.106-1.106c-.71-.516-1.585-.754-2.832-.863"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    x: 8.75,
    y: 2,
    stroke: "#58588D",
    strokeWidth: 1.5,
    rx: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.fb525fb167723404879218a12d063b19.svg";
export { ForwardRef as ReactComponent };